import { ApolloLink } from '@apollo/client';
import {
  createHubHttpLink,
  createBatchedHubHttpLink,
  HubHttpLinkOptions,
  BatchedHubHttpLinkOptions,
} from 'apollo-link-hub-http';
import earlyRequestLink from './earlyRequestLink';
import errorMonitoringLink from './errorMonitoringLink';
import otelLink from './otelLink';
import { ComposedStack } from 'hub-http';

type GetHttpLinkFunction = (getHttpLinkOptions: {
  hubHttpLinkOptions: HubHttpLinkOptions | BatchedHubHttpLinkOptions;
  useBatched: boolean;
  httpStack: ComposedStack;
}) => ApolloLink;

const getHttpLink: GetHttpLinkFunction = function ({
  hubHttpLinkOptions,
  useBatched = true,
  httpStack,
}) {
  if (useBatched) {
    return createBatchedHubHttpLink(httpStack)(
      hubHttpLinkOptions as BatchedHubHttpLinkOptions
    );
  }
  return createHubHttpLink(httpStack)(hubHttpLinkOptions as HubHttpLinkOptions);
};

type GetApiLinkFunction = (apiLinkOptions: {
  hubHttpLinkOptions: HubHttpLinkOptions | BatchedHubHttpLinkOptions;
  useBatched: boolean;
  httpStack: ComposedStack;
}) => ApolloLink;

export const getApiLink: GetApiLinkFunction = function ({
  hubHttpLinkOptions,
  useBatched,
  httpStack,
}) {
  const hubHttpLink = getHttpLink({
    hubHttpLinkOptions,
    useBatched,
    httpStack,
  });

  return ApolloLink.from([
    earlyRequestLink,
    errorMonitoringLink,
    otelLink,
    hubHttpLink,
  ]);
};
